var map = {
	"./news_1.jpg": "6fef",
	"./news_1_1.jpg": "4918",
	"./news_1_2.jpg": "eaa4",
	"./news_1_3.jpg": "c4cc",
	"./news_1_4.jpg": "fedd",
	"./news_2.jpg": "de22",
	"./news_2_1.jpg": "82f3",
	"./news_3.jpg": "cd01",
	"./news_3_1.jpg": "c875",
	"./news_3_2.jpg": "2f89",
	"./news_3_3.jpg": "63e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "86d8";